import React, { createContext, useContext, useState } from "react";

interface WorkspaceSwitchingContextValue {
  isSwitching: boolean;
  setIsSwitching: (v: boolean) => void;
}

const WorkspaceSwitchingContext = createContext<WorkspaceSwitchingContextValue>({
  isSwitching: false,
  setIsSwitching: () => {},
});

export const WorkspaceSwitchingProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isSwitching, setIsSwitching] = useState(false);
  return (
    <WorkspaceSwitchingContext.Provider value={{ isSwitching, setIsSwitching }}>
      {children}
    </WorkspaceSwitchingContext.Provider>
  );
};

export const useWorkspaceSwitching = () => useContext(WorkspaceSwitchingContext);
